<div class="flex w-full justify-center">
  <app-giveaway-dialog class=""></app-giveaway-dialog>
</div>

